import { Link } from "react-router-dom";
import { images } from "@/config/images";

export default function ShippingContact() {
  return (
    <>
      {/* 発送について */}
      <section id="shipping" className="bg-background-50 py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="text-center mb-8">
            <p className="inline-flex items-center gap-2 text-xs md:text-sm font-bold text-primary-700 bg-primary-100 rounded-full px-4 py-1.5 mb-4">
              <i className="ri-truck-line"></i>
              発送について
            </p>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              在庫確認後、3日以内に発送
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {[
              {
                icon: "ri-file-check-line",
                title: "在庫がある場合",
                desc: "在庫確認後、そのまま3日以内に発送いたします。発送前の連絡は行いません。",
              },
              {
                icon: "ri-phone-line",
                title: "在庫がない場合",
                desc: "在庫がない場合は、ご登録いただいた電話番号へご連絡いたします。",
              },
              {
                icon: "ri-bank-line",
                title: "お支払い",
                desc: "銀行振込のみ。商品到着後5日以内にお振込みください。",
              },
            ].map((item) => (
              <div
                key={item.title}
                className="bg-background-100 rounded-lg border border-background-200 p-6"
              >
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-100">
                  <i className={`${item.icon} text-accent-700 text-xl`}></i>
                </div>
                <h3 className="mt-4 text-base font-heading font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>

          {/* 送料案内 */}
          <div className="mt-6 bg-background-100 rounded-lg border border-background-200 p-5 md:p-6">
            <h3 className="text-base font-heading font-bold text-foreground-950 mb-3 flex items-center gap-2">
              <i className="ri-truck-line text-accent-700"></i>
              送料について
            </h3>
            <p className="text-sm text-foreground-700">送料：全国一律2,000円（80サイズまで）</p>
            <p className="text-sm text-foreground-700">北海道・沖縄・離島への発送：＋500円</p>
            <p className="mt-2 text-xs text-foreground-500">
              ※商品価格とは別に送料がかかります。
            </p>
          </div>

          <p className="mt-6 text-sm text-foreground-500 text-center leading-relaxed">
            止め刺しから精肉、発送まで一人で行っているため、状況によって発送が遅れる場合があります。
          </p>
        </div>
      </section>

      {/* LINE / お問い合わせ導線 */}
      <section id="contact" className="bg-primary-500 py-12 md:py-16">
        <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50">
            お問い合わせはこちら
          </h2>
          <p className="mt-3 text-sm md:text-base text-background-50/90 max-w-2xl mx-auto">
            商品についてのご質問・お問い合わせは、公式LINEからお気軽にどうぞ。
          </p>

          {/* LINE QRコード - メインで大きく */}
          <div className="mt-8 flex flex-col items-center">
            <div className="w-full max-w-[200px] md:max-w-xs bg-white rounded-lg overflow-hidden p-4">
              <img
                src={images.lineQr}
                alt="株式会社MEGURI 公式LINE QRコード"
                className="w-full h-full object-contain"
              />
            </div>
            <p className="mt-3 text-sm text-background-50/90">
              QRコードを読み取って公式LINEをお友だち追加
            </p>
          </div>

          <div className="mt-8 pt-6 border-t border-background-50/20">
            <Link
              to="/purchase"
              className="inline-flex items-center justify-center gap-2 w-full sm:w-auto bg-background-50 text-primary-700 text-base md:text-lg font-bold px-10 py-4 rounded-md whitespace-nowrap transition-colors hover:bg-background-100"
            >
              <i className="ri-shopping-bag-line"></i>
              商品を購入する
            </Link>
          </div>
        </div>
      </section>

      {/* Instagram フローティングリンク - 右下 */}
      <a
        href="https://www.instagram.com/satokop3105/"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-40 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center border border-background-200 hover:bg-background-100 transition-colors"
        aria-label="Instagram"
      >
        <i className="ri-instagram-line text-xl text-primary-600"></i>
      </a>
    </>
  );
}